<!-- eslint-disable -->
<template lang="pug">
    svg(:width="elemWidth + 1" :height="elemWidth + 1" fill="none" xmlns="http://www.w3.org/2000/svg")
        circle(:cx="elemWidth / 2 - 0.5" :cy="elemWidth / 2 + 0.5" r="7" stroke="black")
        rect(x="0.5" y="0.5" :width="elemWidth" :height="elemWidth" stroke="black")
</template>

<script>
/*eslint-disable*/

export default {
    props: {
        elemWidth: {
            type: Number,
            default: 40,
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
